import { DSButton, styled } from '@vr/ds-react'

export const Button = styled(DSButton, {
  backgroundColor: 'transparent !important',
  span: {
    fontWeight: '500 !important'
  }
})
